export const pageUrl = {
  EXPLORE: "/explore",
  OUTLET_DETAIL: "/outlet-detail",
  HELP: "/help",
  GENERAL_ENQUIRY: "/general-enquiry",
  RAISED_QUERY: "/raised-query",
  PAY_BILL: "/pay-bill",
  PAYMENT_SUMMARY: "/payment-summary",
  PROFILE: "/profile",
  FEEDBACK: "/feedback",
  RESTAURANT_DETAIL: "/restaurant-detail",
  SEARCH_CITY: "/search-city",
  SEARCH_LOCALITY: "/search-locality",
};
